import { render, staticRenderFns } from "./WelcomeConfirm.vue?vue&type=template&id=1ec41c4a&"
import script from "./WelcomeConfirm.vue?vue&type=script&lang=ts&"
export * from "./WelcomeConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports